export const PORTAL_LINK_PLACEHOLDER = '{{PORTAL_LINK}}';
export const COMPANY_NAME_PLACEHOLDER = '{{COMPANY_NAME}}';
export const CONTACT_FIRST_NAME_PLACEHOLDER = '{{CONTACT_FIRST_NAME}}';
export const DOCUMENT_LIST_PLACEHOLDER = '{{DOCUMENT_LIST}}';

// Fixed document-request section appended after the user-editable introduction.
// Presets store subject + introduction only; this block is always regenerated.
export const ONBOARDING_DOCUMENT_REQUEST_SECTION = `Docs needed for Valuation:

${DOCUMENT_LIST_PLACEHOLDER}

At your earliest convenience, please upload to our secure document portal:
${PORTAL_LINK_PLACEHOLDER}`;

// Built-in templates live in ./templates (one file per template).
export { ONBOARDING_EMAIL_TEMPLATES, RENEWAL_TEMPLATE_ID } from './templates';
